// removed by extract-text-webpack-plugin
module.exports = {"modal":"Modal__modal","modal-sm":"Modal__modal-sm","modalSm":"Modal__modal-sm","modal-centered":"Modal__modal-centered","modalCentered":"Modal__modal-centered","modal-fullscreen":"Modal__modal-fullscreen","modalFullscreen":"Modal__modal-fullscreen"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Modal/Modal.tablet.css
// module id = 505
// module chunks = 8